import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@shared/ui/card';
import { Button } from '@shared/ui/button';
import { ShieldAlert } from 'lucide-react';

export const ForbiddenPage: React.FC = () => {
  return (
    <div className="h-[70vh] flex items-center justify-center">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="h-12 w-12 rounded-full bg-destructive/15 text-destructive flex items-center justify-center mx-auto mb-2">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <CardTitle className="text-xl">Access Restricted (403)</CardTitle>
          <CardDescription>
            You do not possess the required RBAC permissions to access this suite or resource.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-xs text-muted-foreground mb-4">
            Contact your organization administrator to request role privileges.
          </p>
          <Link to="/">
            <Button variant="secondary">Return to Dashboard</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForbiddenPage;
